import {type ReactNode, useRef} from 'react';

import {useCurrentUserState} from 'app/current-user/api';
import {useWidgetIsOpenState} from 'app/settings/hooks';
import {COMMENTS_WIDGET, WidgetIsOpenPayloadType} from 'app/settings/slice';

import type {DetailPageItemType} from 'app/components/general/DetailPage/types';
type Props<ItemType extends DetailPageItemType> = {
  openComponent: ReactNode | null;
  closedComponent: ReactNode | null;
  object: ItemType;
  widgetName: WidgetIsOpenPayloadType['widgetName'];
};

export const useWidgetProps = <ItemType extends DetailPageItemType>(
  object: ItemType,
  widgetName: WidgetIsOpenPayloadType['widgetName']
) => {
  const {is_diagrams_expanded} = useCurrentUserState().data!;
  const widgetProps = useRef<WidgetIsOpenPayloadType>({
    contentType: object.content_type,
    objectId: object.id,
    widgetName,
    defaultValue:
      widgetName === COMMENTS_WIDGET ? is_diagrams_expanded : undefined,
  });

  return widgetProps.current;
};

export const StickyIsOpenGateway = <ItemType extends DetailPageItemType>({
  openComponent,
  closedComponent,
  object,
  widgetName,
}: Props<ItemType>) => {
  const widgetProps = useWidgetProps(object, widgetName);
  const isOpen = useWidgetIsOpenState(widgetProps);

  if (isOpen) {
    return openComponent;
  }

  return closedComponent;
};
